module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    staticClass: "page-on-center rowBackgroundHomepage",
    attrs: {
      "id": "inbox",
      "data-page": "inbox-page",
      "pull-to-refresh": _vm.isSmartphoneOS,
      "infinite-scroll": ""
    },
    on: {
      "ptr:refresh": function($event) {
        return _vm.onRefresh(false)
      },
      "infinite": _vm.onInfinite
    }
  }, [(_vm.isSmartphoneOS) ? _c('div', {
    attrs: {
      "slot": "fixed"
    },
    slot: "fixed"
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "44px",
      "width": "100%"
    }
  }, [(_vm.serviceId === _vm.services.DOCUMENTSERVICE && !_vm.sharedFoldersConfig) ? _c('cm-messages-filter', {
    staticClass: "researchfilter",
    staticStyle: {
      "position": "relative",
      "z-index": "10"
    },
    attrs: {
      "isPayments": "",
      "received": "",
      "filterType": "details",
      "mode": this.mode
    },
    on: {
      "applyFilter": function($event) {
        return _vm.applyFilter($event)
      }
    }
  }) : (_vm.serviceId === _vm.services.DIRECTPAYMENTS && _vm.mode === 0) ? _c('cm-messages-filter', {
    staticClass: "researchfilter",
    staticStyle: {
      "position": "relative",
      "z-index": "10"
    },
    attrs: {
      "isPayments": "",
      "received": "",
      "filterType": "draft",
      "mode": this.mode
    },
    on: {
      "applyFilter": function($event) {
        return _vm.applyFilter($event)
      }
    }
  }) : (_vm.serviceId === _vm.services.PAYMENTS && _vm.mode === 2) ? _c('cm-messages-filter', {
    staticClass: "researchfilter",
    staticStyle: {
      "position": "relative",
      "z-index": "10"
    },
    attrs: {
      "isPayments": "",
      "received": "",
      "filterType": "group",
      "mode": this.mode
    },
    on: {
      "applyFilter": function($event) {
        return _vm.applyFilter($event)
      }
    }
  }) : _c('cm-messages-filter', {
    staticClass: "researchfilter",
    staticStyle: {
      "position": "relative",
      "z-index": "10"
    },
    attrs: {
      "isPayments": "",
      "received": "",
      "filterType": "list",
      "mode": this.mode
    },
    on: {
      "applyFilter": function($event) {
        return _vm.applyFilter($event)
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isSmartphoneOS) ? _c('div', {
    staticClass: "layoutTop"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "listPage",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('b-row', {
    staticClass: "form-group justify-content-start showLargeScreenOnly"
  }, [_c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "disabled": _vm.activateSpinner
    },
    on: {
      "click": function($event) {
        return _vm.refreshInbox()
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "refresh"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fab-label"
  }, [_vm._v(_vm._s(_vm.$t('common.rfrsh')))])], 1)], 1), _vm._v(" "), (_vm.serviceId === _vm.services.SUPPLIERS) ? _c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "href": "/suppliers/create/"
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.add_label')))])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "requestsList"
  }, [(!_vm.isSmartphoneOS) ? _c('div', [(_vm.serviceId === _vm.services.DOCUMENTSERVICE && !_vm.sharedFoldersConfig) ? _c('cm-messages-filter', {
    staticClass: "researchfilter",
    staticStyle: {
      "position": "relative",
      "z-index": "10"
    },
    attrs: {
      "isPayments": "",
      "received": "",
      "filterType": "details",
      "mode": this.mode
    },
    on: {
      "applyFilter": function($event) {
        return _vm.applyFilter($event)
      }
    }
  }) : (_vm.serviceId === _vm.services.DIRECTPAYMENTS && _vm.mode === 0) ? _c('cm-messages-filter', {
    staticClass: "researchfilter",
    staticStyle: {
      "position": "relative",
      "z-index": "10"
    },
    attrs: {
      "isPayments": "",
      "received": "",
      "filterType": "draft",
      "mode": this.mode,
      "randomId": _vm.randomId
    },
    on: {
      "applyFilter": function($event) {
        return _vm.applyFilter($event)
      }
    }
  }) : (_vm.serviceId === _vm.services.PAYMENTS && _vm.mode === 2) ? _c('cm-messages-filter', {
    staticClass: "researchfilter",
    staticStyle: {
      "position": "relative",
      "z-index": "10"
    },
    attrs: {
      "isPayments": "",
      "received": "",
      "filterType": "group",
      "mode": this.mode,
      "randomId": _vm.randomId
    },
    on: {
      "applyFilter": function($event) {
        return _vm.applyFilter($event)
      }
    }
  }) : _c('cm-messages-filter', {
    staticClass: "researchfilter",
    staticStyle: {
      "position": "relative",
      "z-index": "10"
    },
    attrs: {
      "isPayments": "",
      "received": "",
      "filterType": "list",
      "mode": this.mode,
      "randomId": _vm.randomId
    },
    on: {
      "applyFilter": function($event) {
        return _vm.applyFilter($event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSmartphoneOS) ? _c('div', {
    style: (_vm.customMobileLayoutStyle)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0"
    }
  }, [(_vm.activateSpinner || _vm.activateSpinnerDraft || _vm.activateSpinnerGroup) ? _c('spinner') : (_vm.serviceId === _vm.services.DIRECTPAYMENTS && _vm.mode === 0) ? _c('dp-draft-list', {
    attrs: {
      "drafts": _vm.inboxDraft
    }
  }) : (_vm.serviceId === _vm.services.DOCUMENTSERVICE && _vm.mode === 1 && !_vm.sharedFoldersConfig) ? _c('documents-list', {
    attrs: {
      "documents": _vm.inboxMessages
    }
  }) : (_vm.serviceId === _vm.services.SUPPLIERS && _vm.mode === 1) ? _c('suppliers-list', {
    attrs: {
      "sellers": _vm.inboxMessages
    }
  }) : (_vm.serviceId === _vm.services.DOCUMENTSERVICE && _vm.mode === 2) ? _c('document-to-validate-list', {
    attrs: {
      "documents": _vm.inboxMessages
    }
  }) : _c('transactions-list', {
    attrs: {
      "filterBy": _vm.filterBy,
      "messages": _vm.inboxMessages,
      "randomId": _vm.randomId,
      "serviceId": _vm.serviceId
    }
  })], 1)])])], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-03bb03c7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03bb03c7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/InboxPage.vue
// module id = 2316
// module chunks = 2